/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import Spinner from '../Spinner';
import * as S from './style';
import {EButtonAppearance, EButtonSize, TButtonAppearance, TButtonSize} from './types';

export type TButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string;
  hasMarginLeft?: boolean;
  block?: boolean;
  square?: boolean;
  appearance?: TButtonAppearance;
  size?: TButtonSize;
  as?: keyof JSX.IntrinsicElements | React.ComponentType<any>;
  // Link
  href?: string;
  to?: string;
  rel?: string;
  target?: string;
  download?: string | boolean;
};

export type TLoadingButtonProps = TButtonProps & {
  loading?: boolean;
};

const Button = React.memo<TButtonProps>(
  ({type, appearance = EButtonAppearance.tertiary, children, size = EButtonSize.M, ...props}) => {
    const defaultType = props.as ? undefined : 'button';

    return (
      <S.Button {...props} type={type || defaultType} appearance={appearance} size={size}>
        {children}
      </S.Button>
    );
  },
);

const LoadingButton = React.memo<TLoadingButtonProps>(
  ({
    type = 'button',
    loading,
    disabled,
    appearance = EButtonAppearance.tertiary,
    size = EButtonSize.M,
    children,
    onClick,
    ...props
  }) => (
    <S.LoadingButton
      {...props}
      size={size}
      type={type}
      loading={loading}
      appearance={appearance}
      disabled={disabled}
      onClick={loading ? undefined : onClick}
    >
      {loading && (
        <S.SpinnerWrapper>
          <Spinner />
        </S.SpinnerWrapper>
      )}
      <S.Children isHidden={loading}>{children}</S.Children>
    </S.LoadingButton>
  ),
);

export type {TButtonAppearance, TButtonSize};
export {Button, LoadingButton, EButtonAppearance, EButtonSize};
export default Button;
/* eslint-enable react/jsx-props-no-spreading */
